<div class="d-inline-flex align-items-center bg-white tag-activo-invertir">
    <span class="material-symbols-outlined me-2" [ngClass]="{
        'secondary-venture-500': plataforma === 'VENTURE',
        'secondary-estate-500': plataforma === 'REALESTATE',
        'secondary-creative-500': plataforma === 'CREATIVE'}">
        moving
    </span>
    <span class="p3-medium primary-900 mb-0">
        Fase de Sobrefinanciación
    </span>
</div>